<template>
	<div :class="[multipage === true ? 'multi-page' : 'single-page', 'not-menu-page', 'home-page']">
		<a-row :gutter="8" class="head-info">
			<a-card class="head-info-card">
				<a-col :span="12">
					<div class="head-info-avatar"><img alt="头像" :src="avatar" /></div>
					<div class="head-info-count">
						<div class="head-info-welcome">{{ welcomeMessage  + (user.managerNatureValue? user.managerNatureValue : '')}}</div>
						<div class="head-info-desc">
							<p>{{ user.deptName ? user.deptName : '暂无部门' }} | {{ user.job ? user.job : '暂无职位' }}</p>
						</div>
						<div class="head-info-time">上次登录时间：{{ user.lastLoginTime ? user.lastLoginTime : '第一次访问系统' }}</div>
					</div>
				</a-col>
				<a-col :span="12">
					<div>
						<a-row class="more-info">
							<a-col :xs="{ span: 12, offset: 0 }" :xxl="{ span: 6, offset: 8 }">
								<head-info title="今天是你入职蜂群" :content="workDay" :center="false" :bordered="false" />
							</a-col>
							<a-col :span="12" :xxl="4"><head-info title="待处理的工作" :content="works + '个'" :center="false" :bordered="false" /></a-col>
							<a-col :span="12" :xxl="5"><head-info title="今日总共登录数" :content="totalVisitCount" :center="false" /></a-col>
						</a-row>
					</div>
				</a-col>
			</a-card>
		</a-row>
		<a-row :gutter="8" class="count-info">
			<a-col :span="8" class="visit-count-wrapper" v-hasPermission="'reimbursement:homePageTodo'">
				<a-card class="visit-count">
					<div class="titles">
						行政审批
						<span @click="$router.push({ path: '/todoTask/activityTaskList' })">进入审批>></span>
					</div>
					<a-radio-group v-model="value" @change="onManage">
						<a-badge :count="wordCount"><a-radio-button value="1">待办</a-radio-button></a-badge>
						<a-radio-button value="2">办理</a-radio-button>
						<a-radio-button value="3">我发起的</a-radio-button>
					</a-radio-group>
					<div class="home-approval">
						<ul class="approval-list">
							<li class="approval-item" v-for="(item, index) in approval" @click="onApproval(item)">
								<div style="display: flex;justify-content: space-between;">
									<span class="header">{{ item.name }}</span>
									<span>{{ item.userName }}</span>
								</div>
								<span class="commit-time">创建时间: {{ item.createTime }}</span>
							</li>
						</ul>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8" class="visit-count-wrapper" v-hasPermission="'order:homePageTodo'">
				<a-card class="visit-count">
					<div class="titles">
						待办订单
						<span @click="$router.push({ path: '/todoTask/todoTaskList' })">进入待办>></span>
					</div>
					<a-radio-group v-model="valueOrder" @change="changeOrderType">
						<a-badge :count="orderTodoNum"><a-radio-button value="1">待处理订单</a-radio-button></a-badge>
						<a-radio-button value="2">已处理</a-radio-button>
					</a-radio-group>
					<div class="home-approval">
						<ul class="approval-list">
							<li class="approval-item" v-for="(item, index) in orderTaskList" @click="orderDetail(item)">
								<div style="display: flex;justify-content: space-between;">
									<span class="header">{{ item.taskName }}</span>
									<span>&nbsp;</span>
								</div>
								<span class="commit-time" v-if="valueOrder == 1">创建时间: {{ item.createTime }}</span>
								<span class="commit-time" v-if="valueOrder == 2">完成时间: {{ item.operatingTime }}</span>
							</li>
						</ul>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8" class="visit-count-wrapper" v-hasPermission="'commissionItem:homePageTodo'">
				<CommissionItemHome ref="commissionItemHome" @success="num => {this.commissionItemNum = num;}"></CommissionItemHome>
			</a-col>
			<a-col :span="8" class="visit-count-wrapper" v-hasAnyPermission="'report:review,report:push'">
				<a-card class="visit-count">
					<div class="titles">
						待办月报
						<span @click="$router.push({ path: '/OA/monthlyWorkReportList' })">进入月报>></span>
					</div>
					<a-radio-group v-model="valueOrder" @change="getReportDataArr">
						<a-badge :count="todoReport"><a-radio-button value="1" @click="getReportDataArr">待处理月报</a-radio-button></a-badge>
					</a-radio-group>
					<div class="home-approval">
						<ul class="approval-list">
							<li v-hasPermission="'report:review'" class="approval-item" v-for="(item, index) in reportDataArr" @click="readingReport(item)">
								<div style="display: flex;justify-content: space-between;">
									<span class="header">{{ item.createUserName + '的月报' }}</span>
									<span>&nbsp;</span>
								</div>
								<span class="commit-time">汇报时间: {{ item.reportTime }}</span>
							</li>
							<li v-hasPermission="'report:push'" class="approval-item" v-for="(item, index) in reportDataArr" @click="examineReport(item)">
								<div style="display: flex;justify-content: space-between;">
									<span class="header">{{ item.createUserName + '的月报' }}</span>
									<span>&nbsp;</span>
								</div>
								<span class="commit-time">汇报时间: {{ item.reportTime }}</span>
							</li>
						</ul>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8" class="visit-count-wrapper" v-hasPermission="'accountApply:homePageTodo'">
				<AccountPriceHome @success="num => {this.accountTodoNum = num;}"></AccountPriceHome>
			</a-col>
			<a-col :span="8" class="visit-count-wrapper" v-hasPermission="'meeting:homePageTodo'">
				<a-card class="visit-count">
					<div class="titles">
						我的会议
						<span @click="$router.push({ path: '/OA/meeting/myMeeting' })">进入我的会议>></span>
					</div>
					<a-radio-group v-model="meetingDays" @change="meetingDaysChange">
						<a-radio-button value="7">最近七天</a-radio-button>
						<a-radio-button value="30">最近三十天</a-radio-button>
					</a-radio-group>
					<div class="home-approval">
						<ul class="approval-list">
							<li class="approval-item" v-for="(item, index) in myMeetingArr" @click="viewDetails(item)">
								<div style="display: flex;justify-content: space-between;">
									<a-badge :count="item.read ? item.read : 0" dot>
										<span class="header">{{ item.title }}</span>
									</a-badge>
									<span>{{ item.placeName }}</span>
								</div>
								<span class="commit-time">会议开始时间: {{ item.startTime }}</span>
							</li>
						</ul>
					</div>
				</a-card>
			</a-col>
			<a-col :span="16" class="visit-count-wrapper" v-hasPermission="'official:homePageTodo'">
				<a-card class="visit-count">
					<div class="titles">
						公告
						<span @click="$router.push({ path: 'officialList' })">进入公告>></span>
					</div>
					<div style="height: 330px;">
						<custom-page :columns="columns" :url="url" ref="table">
							<template slot="format1" slot-scope="scope">
								<div class="title">
									<a-tag color="red" v-if="scope.record.unread == 0">未读</a-tag>
									<a-tag v-else>已读</a-tag>
								</div>
							</template>
							<template slot="format3" slot-scope="scope">
								<a-tag color="red" v-if="scope.record.setting == 1">置顶</a-tag>
								<!--<a-tag v-else>未置顶</a-tag>-->
								<a href="javascript:;" @click="lookDetail(scope.record)">{{ scope.record.title }}</a>
							</template>
							<template slot="format2" slot-scope="scope">
								<h4 style="margin:0;">{{ scope.record.typeName }}</h4>
							</template>
						</custom-page>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8" class="visit-count-wrapper" v-hasPermission="'qualityConten:homePageTodo'">
				<QualityContentHome @success="num => {this.qulityContentNum = num;}"></QualityContentHome>
			</a-col>
		</a-row>
		<a-modal title="公告详情" :visible="visible" :footer="null" :closable="false" width="50%">
			<a-form>
				<div>
					<h2 style="text-align: center;">{{ noticeDetails.title }}</h2>
					<div style="display: flex;justify-content: space-around;">
						<span>发送人：{{ noticeDetails.uName }}</span>
						<span>发送时间：{{ noticeDetails.createTime }}</span>
					</div>
					<div style="padding:10px;margin: 10px 0;" v-html="noticeDetails.content"></div>
				</div>
				<a-form-item label="附件" v-bind="formItemLayout">
					<UploadFile :params="fileParams" :defaultFileList="fileArr" :isDisplay="false"></UploadFile>
					<div v-if="fileArr.length == 0">无</div>
					<a-button v-if="fileArr.length != 0" type="primary" @click="downloadEmployeeZip">全部导出</a-button>
				</a-form-item>
			</a-form>
			<a-button type="primary" v-if="!countDown" style="margin-left: 50%;transform:translateX(-50%)" @click="reset">完成</a-button>
			<a-button type="primary" v-if="countDown" style="margin-left: 50%;transform:translateX(-50%)" disabled>完成({{ countTime }})</a-button>
		</a-modal>
		<ApprovalUnit :visibleApproval="visibleApproval" @stayDo="stayDo" ref="approvalUnit"></ApprovalUnit>
		<monthly-work-report ref="workReport" :title="'月报处理'" :visible="reportShow" @close="reportShowHandle" @success="reportSearch()" />
	</div>
</template>
<script>
import { classify, folder } from '@/utils/fileSetting';
import UploadFile from '@/views/common/UploadFile';
import AccountPriceHome from '@/views/account/accountChange/accountPrice/accountPriceHome';
import QualityContentHome from '@/views/OA/qualityContent/approvalHome';
import CommissionItemHome from '@/views/commission/accountCommissionItem/approvalHome';
import ApprovalUnit from '@/views/task/todoTask/approvalUnit';
import CustomPage from '@/views/common/CustomPage';
import HeadInfo from '@/views/common/HeadInfo';
import { mapState } from 'vuex';
import moment from 'moment';
import monthlyWorkReport from './OA/monthlyWorkReportList/monthlyWorkReport';
moment.locale('en');

const table = {
	searchForm: {
		unread: '',
		typeId: '',
		startTime: '',
		endTime: ''
	},
	url: 'officialDoc/currentUser',
	columns: [
		{
			title: '标题',
			dataIndex: 'title',
			scopedSlots: { customRender: 'format3' },
			width: 500
			//    align: 'center'
		},
		{
			title: '分类',
			dataIndex: 'typeName',
			scopedSlots: { customRender: 'format2' },
			align: 'center'
		},
		{
			title: '创建日期',
			dataIndex: 'createTime',
			align: 'center'
		},
		{
			title: '发送人',
			dataIndex: 'uName',
			align: 'center'
		},
		{
			title: '状态',
			dataIndex: 'unread',
			scopedSlots: { customRender: 'format1' },
			align: 'center',
			width: 100
		}
	]
};

export default {
	name: 'HomePage',
	components: { HeadInfo, CustomPage, ApprovalUnit, UploadFile, AccountPriceHome, QualityContentHome, monthlyWorkReport,CommissionItemHome },
	data() {
		return {
			formItemLayout: {
				labelCol: {
					xs: { span: 24 },
					sm: { span: 3 }
				},
				wrapperCol: {
					xs: { span: 24 },
					sm: { span: 21 }
				}
			},
			noticeDetails: {},
			fileArr: [],
			fileParams: {
				folder: folder.official,
				classify: classify.official
			},
			visible: false, // 公告详情
			visibleApproval: false, // 审批详情
			value: '1', // 审批
			valueOrder: '1',
			approval: [],
			...table,
			series: [],
			meetingDays: '7',
			meetingParam: {
				startStr: null,
				endStr: null
			},
			myMeetingArr: [],
			chartOptions: {
				chart: {
					toolbar: {
						show: false
					}
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '35%'
					}
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					show: true,
					width: 2,
					colors: ['transparent']
				},
				xaxis: {
					categories: []
				},
				fill: {
					opacity: 1
				}
			},
			workDay: '',
			todayVisitCount: '',
			wordCount: 0,
			totalVisitCount: 0,
			userRole: '',
			userDept: '',
			lastLoginTime: '',
			welcomeMessage: '',
			jumpNotification: true,
			countDown: false,
			countTime: 0,
			orderTaskList: [],
			bloggerOrderTaskList: [],
			orderTodoNum: 0,
			bloggerTodoNum: 0,
			bloggerOrderValue: '0',
			accountTodoNum: 0,
			qulityContentNum: 0,
			commissionItemNum: 0,
			reportDataArr: [],
			todoReport: 0,
			reportShow: false,
			reportTitle: '',
			reminderMsg: [],
			reminderMsgVisible: false
		};
	},
	computed: {
		...mapState({
			multipage: state => state.setting.multipage,
			user: state => state.account.user,
			domainPath: state => state.setting.domainPath
		}),
		avatar() {
			let avatar = this.user.avatar;
			if (avatar == 'default.jpg') {
				return 'static/avatar/default.jpg';
			}
			return this.domainPath + avatar;
		},
		works() {
			return this.orderTodoNum + this.bloggerTodoNum + this.wordCount + this.accountTodoNum + this.qulityContentNum + this.commissionItemNum;
		}
	},
	methods: {
		viewDetails(val) {
			this.$router.push({
				path: 'OA/meeting/meetingDetails',
				query: {
					id: val.id
				}
			});
		},
		meetingDaysChange(e) {
			this.meetingParam.endStr = moment(this.meetingParam.startStr, 'YYYY-MM-DD')
				.add(Number(e.target.value), 'days')
				.format('YYYY-MM-DD');
			this.getMeetingArr();
		},
		downloadEmployeeZip(item) {
			this.$download('file/downloadFile/official/' + this.fileArr[0].dataId, {}, '公文附件包.zip').then(res => {
				//					console.log(res);
			});
		},
		search() {
			// 公告
			this.searchForm.pageNum = 1;
			this.$refs.table.handleList(this.searchForm);
		},
		reset() {
			this.noticeDetails = '';
			this.searchForm.unread = '';
			this.searchForm.title = '';
			this.searchForm.startTime = '';
			this.searchForm.endTime = '';
			this.visible = false;
			this.search();
		},
		lookDetail(value) {
			var that = this;
			that.$post('officialDocUser/tabRead', { docusId: value.docusId.toString() }).then(() => {
				that.$refs.table.resetSelectRowKeys();
				that.$get(`file/fileList/${this.fileParams.classify}/${value.id}`).then(res => {
					that.fileArr = res.data;
				});
				that.noticeDetails = value;
				that.visible = true;
				if (value.unread == 0) {
					that.countDown = true;
					that.countTime = 5;
					var timing = setInterval(function() {
						that.countTime -= 1;
						if (that.countTime <= 0) {
							clearInterval(timing);
							that.countDown = false;
						}
					}, 1000);
				}
			});
		},
		openNotification() {
			var that = this;
			this.$get('officialDoc/currentUser', { unread: 0 }).then(r => {
				if (r.data.rows && r.data.rows.length > 0) {
					that.$notification.open({
						message: '未读公文',
						description: r.data.rows[0].title,
						placement: 'bottomRight',
						duration: 6,
						icon: <a-icon type="bell" style="color:red;" theme="filled" />,
						style: {
							cursor: 'pointer'
						},
						onClick() {
							if (that.jumpNotification == true) {
								that.$router.push({
									path: 'officialList'
								});
								that.jumpNotification = false;
							}
						},
						onClose(e) {
							that.jumpNotification = false;
						}
					});
				}
			});
		},
		checkWhetherHasPriceApplyTodo() {
			var that = this;
			this.$get('accountPriceApply/checkWhetherHasPriceApplyTodo').then(r => {
				if (r.data) {
					let key = 'priceApplyTodo';
					that.$notification.open({
						message: '报价申请提醒',
						description: '本月还未审批完所有报价申请，请尽快进行审批',
						placement: 'bottomRight',
						duration: 6,
						icon: <a-icon type="bell" style="color:red;" theme="filled" />,
						style: {
							cursor: 'pointer'
						},
						onClick() {
							that.$router.push({
								path: 'noticeList'
							});
							that.$notification.close(key);
						},
						key
					});
				}
			});
		},
		welcome() {
			const date = new Date();
			const hour = date.getHours();
			let time = hour < 6 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour <= 18 ? '下午好' : '晚上好';
			let welcomeArr = [
				'喝杯咖啡休息下吧☕',
				'要不要和朋友打局LOL',
				'要不要和朋友打局王者榮耀',
				'幾天沒見又更好看了呢😍',
				'今天又寫了幾個Bug🐞呢',
				'今天在群裡吹水了嗎',
				'今天吃了什麼好吃的呢',
				'今天您微小了麼😊',
				'今天幫助別人解決問題了嗎',
				'準備吃些什麼',
				'週末要不要去看電影？'
			];
			//    let index = Math.floor((Math.random() * welcomeArr.length))
			//    return `${time}，${this.user.username}，${welcomeArr[index]}`
			return `${time}，${this.user.realname} !    `;
		},
		/* 行政审批 */
		stayDo() {
			this.$get('activiti/task/getTaskPageByUser', { type: this.value }).then(r => {
				if (this.value == 1) {
					this.wordCount = 0;
					this.wordCount = this.wordCount + r.data.total;
				}
				this.approval = r.data.rows;
			});
		},
		/* 订单待办 */
		changeOrder() {
			this.$get('flowTask/getPageAll', { type: this.valueOrder }).then(res => {
				let result = res.data;
				this.orderTaskList = result.dataList;
				this.orderTodoNum = result.count;
			});
		},
		/* 入职天数,部门名称，职称 */
		workDays() {
			this.$get('employee/getWorkDayByUser').then(r => {
				if (!r.data) {
					this.user.deptName = '';
					this.user.job = '';
					this.workDay = ' -- ';
					this.user.number = r.data.number;
					this.user.managerNatureValue = '';
					return;
				}
				this.user.deptName = r.data.deptName;
				this.user.job = r.data.job;
				this.user.number = r.data.number;
				this.user.managerNatureValue = r.data.managerNatureValue;
				if (!r.data.workDay) {
					this.workDay = ' -- ';
					return;
				}
				this.workDay = '第' + r.data.workDay + '天';
			});
		},
		/* 审批状态切换 */
		onManage(e) {
			this.value = e.target.value;
			this.stayDo();
		},
		/* 待办状态切换 */
		changeOrderType(e) {
			this.valueOrder = e.target.value;
			this.changeOrder();
		},
		onApproval(v) {
			this.visibleApproval = true;
			v.procinstId = v.executionId;
			this.$refs.approvalUnit.hisActivity(v);
		},
		orderDetail(record) {
			let uuid = record.uuid;
			this.$get(`order/getByUuid`, { uuid: uuid }).then(res => {
				let order = res.data;
				if (this.valueOrder == 1) {
					let arr = ['sales_account_manager', 'execution_media_resubmit', 'broker_resubmit', 'business_development_resubmit','redbook_business_resubmit','own_resubmit'];
					if (arr.includes(order.orderStatus)) {
						this.$get(`orderPrep/getOrderPrepByOrderId/${order.id}`).then(res => {
							this.$router.push({
								path: '/todoTask/editOrder',
								query: {
									uuid: res.data.uuid
								}
							});
						});
					} else {
						// 运营部组长确认 跳转到博主页面
						if (order.orderStatus == 'operation_team_leader') {
							this.$router.push({
								path: '/order/bloggerOrderDetail',
								query: {
									uuid: record.uuid,
									approval: 1
								}
							});
						} else {
							this.$router.push({
								path: '/order/orderDetail',
								query: {
									uuid: record.uuid
								}
							});
						}
					}
				} else {
					if (record.dealType && record.dealType == 1) {
						this.$router.push({
							path: '/order/bloggerOrderDetail',
							query: {
								uuid: record.uuid,
								approval: 1
							}
						});
					} else {
						this.$router.push({
							path: '/order/orderDetail',
							query: {
								uuid: record.uuid
							}
						});
					}
				}
			});
		},
		bloggerOrderDetail(record) {
			this.$router.push({
				path: 'order/bloggerOrderDetail',
				query: {
					uuid: record.uuid
				}
			});
		},
		bloggerOrderList() {
			this.$get(`order/selectBloggerTodoOrderList/${this.bloggerOrderValue}`).then(res => {
				let result = res.data;
				this.bloggerOrderTaskList = result.dataList;
				this.bloggerTodoNum = result.count;
			});
		},
		bloggerOrderChange(e) {
			this.bloggerOrderValue = e.target.value;
			this.bloggerOrderList();
		},
		getMeetingArr() {
			this.$get(`meeting/myList`, this.meetingParam).then(res => {
				this.myMeetingArr = res.data;
			});
		},
		getReportDataArr() {
			this.$get('monthlyWorkReport/getToDoMonthlyReport').then(res => {
				let check = res == null;
				if (check) {
					this.reportDataArr = [];
					this.todoReport = 0;
					return;
				}
				this.reportDataArr = [];
				let rows = res.data.rows;
				if (rows) {
					for (let i = 0; i < rows.length; i++) {
						let item = rows[i];
						item.reportTime = moment(item.reportTime).format('YYYY-MM-DD HH:mm:ss');
						this.reportDataArr.push(item);
					}
				}
				this.todoReport = res.data.total;
			});
		},
		reportShowHandle(show) {
			this.reportShow = !show;
		},
		reportSearch() {
			this.getReportDataArr();
		},
		readingReport(item) {
			let that = this;
			that.$nextTick(() => {
				that.reportTitle = '批阅';
				item.disabled = true;
				item.reading = true;
				that.$refs.workReport.init(item);
				this.reportShowHandle();
			});
		},
		examineReport(item) {
			let that = this;
			that.$nextTick(() => {
				that.reportTitle = '审批';
				item.disabled = true;
				item.examine = true;
				if (item.status === '2') {
					item.isPush = true;
				}
				that.$refs.workReport.init(item);
				this.reportShowHandle();
			});
		},
		getOfficialMsg() {
			var that = this;
			let params = {
				unread: 0,
				title: '新增账号提醒'
			};
			this.$get('officialMsg/myMsg', params).then(res => {
				if (res.data.total > 0) {
					that.$notification.open({
						message: '新增用户消息',
						description: res.data.rows[0].content,
						placement: 'bottomRight',
						duration: 6,
						icon: <a-icon type="bell" style="color:red;" theme="filled" />,
						style: {
							cursor: 'pointer'
						},
						onClick() {
							if (that.jumpNotification == true) {
								that.$router.push({
									path: 'noticeList'
								});
								that.jumpNotification = false;
							}
						},
						onClose(e) {
							that.jumpNotification = false;
						}
					});
				}
			});
		},
		getInvoiceMsg() {
			var that = this;
			let params = {
				unread: 0,
				dataType: 'tb_invoice_reminder'
			};
			this.$get('officialMsg/myMsg', params).then(res => {
				if (res.data.total > 0) {
					that.$notification.open({
						message: '抄送发票消息',
						description: res.data.rows[0].content,
						placement: 'bottomRight',
						duration: 6,
						icon: <a-icon type="bell" style="color:red;" theme="filled" />,
						style: {
							cursor: 'pointer'
						},
						onClick() {
							if (that.jumpNotification == true) {
								that.$router.push({
									path: 'noticeList'
								});
								that.jumpNotification = false;
							}
						},
						onClose(e) {
							that.jumpNotification = false;
						}
					});
				}
			});
		},
		changeCommission() {
			this.$refs.commissionItemHome.init();
		},
		receive() {
			this.reminderMsgVisible = false;
		}
	},
	mounted() {
		let that = this;
		this.$root.Bus.$on('homeActivityTaskList',function(){
			that.stayDo();
		})
		this.workDays();
		this.welcomeMessage = this.welcome();
		this.getOfficialMsg();
		this.getInvoiceMsg();
		this.meetingParam.startStr = moment(new Date()).format('YYYY-MM-DD');
		this.meetingParam.endStr = moment(new Date()).add(Number(this.meetingDays), 'days').format('YYYY-MM-DD');
		this.getMeetingArr();
		this.getReportDataArr();
		this.openNotification();
		this.search();
		this.stayDo();
		this.changeOrder();
		this.bloggerOrderList();
		this.checkWhetherHasPriceApplyTodo();
		this.$get(`index/${this.user.username}`).then(r => {
			let data = r.data.data;
			this.totalVisitCount = data.todayVisitCount;
			let sevenVisitCount = [];
			let dateArr = [];
		});
		this.$root.Bus.$on('homeTodoTaskList', function() {
			that.changeOrder();
			that.bloggerOrderList();
			that.changeCommission();
		});
	}
};
</script>
<style lang="less">
.home-page {
	.head-info {
		margin-bottom: 0.5rem;
		.head-info-card {
			padding: 0.5rem;
			border-color: #f1f1f1;
			.head-info-avatar {
				display: inline-block;
				float: left;
				margin-right: 1rem;
				img {
					width: 5rem;
					border-radius: 2px;
				}
			}
			.head-info-count {
				display: inline-block;
				float: left;
				.head-info-welcome {
					font-size: 1.05rem;
					margin-bottom: 0.1rem;
				}
				.head-info-desc {
					color: rgba(0, 0, 0, 0.45);
					font-size: 0.8rem;
					padding: 0.2rem 0;
					p {
						margin-bottom: 0;
					}
				}
				.head-info-time {
					color: rgba(0, 0, 0, 0.45);
					font-size: 0.8rem;
					padding: 0.2rem 0;
				}
			}
		}
	}
	.count-info {
		margin-bottom: 0.5rem;
		.visit-count-wrapper {
			margin-bottom: 5px;
			padding-left: 0 !important;
			.visit-count {
				padding: 0.5rem;
				border-color: #f1f1f1;
				.ant-card-body {
					padding: 0.5rem 1rem !important;
				}
				.titles {
					margin-bottom: 0.5rem;
					color: #2e3242;
					font-size: 18px;
					span {
						color: #3f9ee8;
						font-size: 12px;
						margin-left: 5px;
						cursor: pointer;
					}
				}
				.home-approval {
					height: 290px;
					margin-top: 8px;
					overflow: hidden;
					ul,
					li {
						list-style: none;
						padding: 0;
					}
					.approval-item {
						position: relative;
						margin-top: 12px;
						padding-bottom: 12px;
						border-bottom: 1px solid #e6e9f5;
						cursor: pointer;
						.header {
							font-size: 14px;
							color: #3f9ee8;
							font-weight: 500;
							line-height: 1;
						}
						.commit-time {
							display: block;
							margin: 8px 0 0;
							padding: 0;
							font-size: 12px;
							color: #9da2b3;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.commit-status {
							position: absolute;
							display: block;
							top: -2px;
							right: 0;
							font-size: 12px;
							line-height: 18px;
							width: 52px;
							border-radius: 2px;
							text-align: center;
						}
						.going {
							color: #f5a22f;
							border: 1px solid #f7b458;
							background: #fffcf7;
						}
					}
				}
			}
		}
		.project-wrapper {
			padding-right: 0 !important;
			.project-card {
				border: none !important;
				.ant-card-head {
					border-left: 1px solid #f1f1f1 !important;
					border-top: 1px solid #f1f1f1 !important;
					border-right: 1px solid #f1f1f1 !important;
				}
				.ant-card-body {
					padding: 0 !important;
					table {
						width: 100%;
						td {
							width: 50%;
							border: 1px solid #f1f1f1;
							padding: 0.6rem;
							.project-avatar-wrapper {
								display: inline-block;
								float: left;
								margin-right: 0.7rem;
								.project-avatar {
									color: #42b983;
									background-color: #d6f8b8;
								}
							}
						}
					}
				}
				.project-detail {
					display: inline-block;
					float: left;
					text-align: left;
					width: 78%;
					.project-name {
						font-size: 0.9rem;
						margin-top: -2px;
						font-weight: 600;
					}
					.project-desc {
						color: rgba(0, 0, 0, 0.45);
						p {
							margin-bottom: 0;
							font-size: 0.6rem;
							white-space: normal;
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue